import en from "./en/index";
import fr from "./fr/index";
// import th from "./th/index";
// import it from "./it/index";

export const defaultLocale = "en";

export const languages = {
  en: en,
  fr: fr
  // th: th,
  // it: it
};
